import Link from 'next/link'

export default function TutorProfileSubjectList({tutorProfile, subjects}) {
  const subjectsCount = subjects.length
  const truncateLimit = 6
  const truncatedSubjects = (() => {
    return subjects.slice(0, truncateLimit)
  })()
  const isTruncated = subjectsCount > truncateLimit
  const excludedSubjectsCount = subjectsCount - truncateLimit

  return (
    <div className="d-flex flex-wrap">
      {truncatedSubjects.map(subject => (
        <span className="me-2 mb-2 p-2 bg-light rounded" key={subject.id}>
          <span className="small">{subject.name}</span>
        </span>
      ))}

      {isTruncated &&
        <span className="mb-2 p-2">
          <span className="small">
            <Link href={`/tutors/${tutorProfile.slug}`} passHref>
              +{excludedSubjectsCount}more
            </Link>
          </span>
        </span>
      }
    </div>
  )
}
